


























































































































import { Component, Vue } from 'vue-property-decorator'
import { AuthService as _authService } from '@/services/auth.service'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import { UserService as _userService } from '@/services/user.service'
import { ValidationObserver } from 'vee-validate'

@Component
export default class Profil extends Vue {
  // Refs
  $refs!: {
    passwordForm: InstanceType<typeof ValidationObserver>;
  }

  // Data
  private currentUser: UserInfoDto | null = null;
  private passwordForm = { oldPassword: '', newPassword: '', newPasswordRepeat: '' }

  // Getters
  get userName() {
    if (!this.currentUser?.firstName && !this.currentUser?.lastName) return this.currentUser?.userName

    return `${this.currentUser.firstName} ${this.currentUser.lastName} (${this.currentUser.userName})`
  }

  // Methods
  private async changePassword(event: any) {
    event.preventDefault()

    const isPasswordFormValid = await this.$refs.passwordForm.validate()
    if (!isPasswordFormValid) return

    _userService.changePassword(this.passwordForm.oldPassword, this.passwordForm.newPassword)
  }

  private setState(text: string, condition: Function) {
    if (!text.length) return null

    return condition(text)
  }

  // Lifecycle
  created() {
    _authService.currentUser().subscribe(userInfo => {
      this.currentUser = userInfo
    })
  }
}
